import user from "./dashboard-module/user.svg";
import document from "./dashboard-module/document.svg";
import accounting from "./dashboard-module/accounting.svg";
import inventory from "./dashboard-module/inventory.svg";
import project from "./dashboard-module/project.svg";
import procurement from "./dashboard-module/procurement.svg";
import manufacturing from "./dashboard-module/manufacturing.svg";
import crm from "./dashboard-module/crm.svg";
import hrms from "./dashboard-module/hrms.svg";
import office from "./dashboard-module/office.svg";
import rental from "./dashboard-module/rental.svg";
import settings from "./dashboard-module/settings.svg";
import addModule from "./dashboard-module/add-module.svg";
import logo from "./dashboard-module/logo.svg";
import favicon from "./dashboard-module/erp-fav.svg";
import logout from "./dashboard-module/logout.svg";
import tickicon from "./dashboard-module/tick-circle.svg";
import notification from "./dashboard-module/notification.svg";
import question from "./dashboard-module/question.svg";
import vdivider from "./dashboard-module/v-divider.svg";
import erp_logo from "./dashboard-module/erp_logo.svg";
import alert from "./dashboard-module/alert.svg";
import more from "./dashboard-module/more.svg";
import search from "./dashboard-module/search.svg";
import vendorPerformance from "./common-svg/vendor-performance.svg";
import customerPerformance from "./common-svg/customer-performance.svg";
import cashFlow from "./common-svg/cash-flow.svg";
import fileUpload from "./common-svg/file-upload.svg";
import accountPayable from "./common-svg/account-payable.svg";
import accountReceivable from "./common-svg/account-receivable.svg";
import financialSummery from "./common-svg/financial-summery.svg";
import boxTickGreen from "./common-svg/box-tick-green.svg";
import expandIcon from "./common-svg/expand-icon.svg";
import threeDotIcon from "./common-svg/three-dot.svg";
// Sidebar icons
import documentIcon from "./sidebar/document.svg";
import userIcon from "./sidebar/user.svg";
import roles from "./sidebar/roles.svg";
import setting from "./sidebar/setting.svg";
import accountingIcon from "./sidebar/accounting.svg";
import inventoryIcon from "./sidebar/inventory.svg";
import procurementIcon from "./sidebar/procurement.svg";
import manufacturingIcon from "./sidebar/manufacturing.svg";
import projectIcon from "./sidebar/project.svg";
import crmIcon from "./sidebar/crm.svg";
import purchaseIcon from "./sidebar/purchase-icon.svg";
import hrmsIcon from "./sidebar/hrms.svg";
import officeIcon from "./sidebar/office.svg";
import rentalIcon from "./sidebar/rental.svg";
import journalEntry from "./sidebar/journal-entry.svg";
import paymentEntry from "./sidebar/payment-entry.svg";
import paymentRequest from "./sidebar/payment-request.svg";
import invoice from "./sidebar/invoice.svg";
import reports from "./sidebar/reports.svg";
import credits from "./sidebar/credits.svg";
import expenseReimbursement from "./sidebar/expense-re.svg";
import commission from "./sidebar/commission.svg";
import assets from "./sidebar/assets.svg";
import budget from "./sidebar/budget.svg";
import audit from "./sidebar/audit.svg";
import masterData from "./sidebar/master-data.svg";
import product from "./sidebar/product.svg";
import configuration from "./sidebar/configuration.svg";
import operations from "./sidebar/operations.svg";
import notes from "./sidebar/notes.svg";
import shoppingCart from "./sidebar/shopping-cart.svg";
import book from "./sidebar/book.svg";
import calendar2 from "./sidebar/calendar.svg";
import calendarEdit from "./sidebar/calendar-edit.svg";
import task from "./sidebar/task.svg";
import boxTick from "./sidebar/box-tick.svg";
import box from "./sidebar/book.svg";
import hierarchy from "./sidebar/hierarchy.svg";
import chartFail from "./sidebar/chart-fail.svg";
import report2 from "./sidebar/report-two.svg";
import invoicing from "./sidebar/invoicing.svg";

import accountSideBarSettings from "./sidebar/settings.svg";
import avatarIcon from "./common-component/avatar.svg";
import avatar from "./common-component/avatar.png";
import chat from "./common-component/chat.svg";
import dashboard from "./common-component/dashboard.svg";

import TableIcon from "./view-modal/table-icon";
import CalenderIcon from "./view-modal/calendar-icon";
import GanttIcon from "./view-modal/gantt-icon";
import KanbanIcon from "./view-modal/kanban-icon";
import GridIcon from "./view-modal/grid-icon";
import ChartIcon from "./view-modal/chart-icon";

import calendar from "./view-modal/calendar.svg";
import table from "./view-modal/table.svg";
import grid from "./view-modal/grid.svg";
import gantt from "./view-modal/gantt.svg";
import kanban from "./view-modal/kanban.svg";

// common
import clearIcon from "./common-svg/clear-icon.svg";
import editIcon from "./common-svg/edit-icon.svg";
import calenderIcon from "./common-svg/calender-icon.svg";
import addIcon from "./common-svg/add-icon.svg";
import resizeCardIcon from "./common-svg/resize-card-icon.svg";
import eyeSlashIcon from "./common-svg/eye-slash-icon.svg";
import replaceIcon from "./common-svg/replace-icon.svg";
import eyeIcon from "./common-svg/eye-icon.svg";
import dotsIcon from "./common-svg/dots-icon.svg";
import arrowIcon from "./common-svg/arrow-icon.svg";
import saveFilterIcon from "./common-svg/save-filter-icon.svg";
import renameIcon from "./common-svg/rename-icon.svg";
import folderAdd from "./common-svg/folder-add.svg";
import folderUpload from "./common-svg/document-upload.svg";
import folderCloud from "./common-svg/folder-cloud.svg";
import arrowRight from "./common-svg/arrow-right.svg";
import status from "./common-svg/status.svg";
import directInbox from "./common-svg/direct-inbox.svg";
import calendarTab from "./common-svg/calendar.svg";
import tickCircle from "./common-svg/tick-circle.svg";
import arrow from "./common-svg/arrow.svg";
import arrowRightCircle from "./common-svg/arrow-right-circle.svg";
import arrowDownCircle from "./common-svg/arrow-down-circle.svg";
import gridViewData from "./common-svg/grid.svg";
import textViewData from "./common-svg/text.svg";
import printer from "./common-svg/printer.svg";
import tableNoData from "./common-svg/table-no-data.svg";
import operatinPlay from "./common-svg/manu-play.svg";
import operationBlock from "./common-svg/manu-block.svg";
import operationComplete from "./common-svg/manu-complete.svg";
import ArrowDown from "./common-svg/arrow-down.svg";
import ArrowUp from "./common-svg/arrow-up.svg";
import swap from "./common-svg/swap.svg";
import collapse from "./common-svg/collapse.svg";
import expand from "./common-svg/expand.svg";
import document_text from "./common-svg/document-text.svg";
import document_text2 from "./common-svg/document-text-two.svg";
import notification_manu from "./common-svg/notification-manu.svg";
import manu_block from "./common-svg/manu-block.svg";
import manu_play from "./common-svg/manu-play.svg";
import manu_completed from "./common-svg/manu-complete.svg";
import forwardIcons from "./common-svg/table-forward-item.svg";
import uploadIcon from "./common-svg/upload-icon.svg";

// fallback
import userFallback from "./fallback/userFallback.svg";
import roleFallback from "./fallback/roleFallback.svg";
import settingsFallback from "./fallback/settingsFallback.svg";
import invoiceFallback from "./fallback/invoiceFallback.svg";
import reportsFallback from "./fallback/reportsFallback.svg";
import demandasFallback from "./fallback/demandasFallback.svg";
import operationFallback from "./fallback/operationFallback.svg";
import shippmentFallback from "./fallback/shippmentFallback.svg";
import deliveryOrderFallback from "./fallback/delivery-order.svg";
// Upload icons
import empty from "./common-component/upload/empty.svg";
import close from "./common-component/upload/close.svg";
import folder from "./common-component/upload/folder.svg";
import tick from "./common-component/upload/tick.svg";
import uploading from "./common-component/upload/uploading.svg";
import docFile from "./common-component/upload/document.svg";
import documentPDF from "./common-component/upload/document-pdf.svg";
import trash from "./common-component/upload/trash.svg";
import monitor from "./common-component/upload/monitor.svg";
import documentUpload from "./common-component/upload/document-upload.svg";
import documentUploadWhite from "./common-component/upload/document-upload-white.svg";
import coupon from "./common-component/upload/coupon.svg";
import applyBadge from "./common-component/upload/apply-badge.svg";

import camera from "./common-component/upload/camera.svg";

import uploadDocument from "./common-component/document-upload.svg";
import uploadImage from "./common-component/image-upload.svg";
import info from "./common-component/info.svg";
import url from "./common-component/url.svg";
import sms from "./common-component/sms.svg";
import location from "./common-component/location.svg";
import dollar from "./common-component/dollar-circle.svg";
// import dollarPendingBilling from "./common-component/dollar-pending-billing.svg";
import ArrowDownFill from "./common-svg/ArrowDownFill.svg";
//document icon
import file from "./document/file.svg";
import docfolder from "./document/docfolder.svg";
import gallery from "./document/gallery.svg";
import mp4 from "./document/mp4.svg";
import pdf from "./document/pdf.svg";

//rbac icon
import trashIcon from "./rbac/trash.svg";

import relation from "./common-component/relation.svg";
// shared page
import calendarView from "./shared-page/calendar.jpg";
import ganttView from "./shared-page/gantt.jpg";
import gridView from "./shared-page/grid.jpg";
import kanbanView from "./shared-page/kanban.jpg";
import tableView from "./shared-page/table.jpg";
import duplicate from "./common-svg/duplicate.svg";

/*  Login */
import LoginLeftBg from "./login/login-left-bg.png";
import LoginLeftSiteImage from "./login/login-left-site-image.png";

/*  Inventory */
import InventoryItem from "./inventory/inventory-item.svg";

import edit from "./common-svg/edit.svg";
import PackageIcon from "./common-svg/package-icon.svg";
import TraceDetailIcon from "./common-svg/trace-detail-icon.svg";
import ArrowCircleUpIcon from "./common-svg/arrow-up-circle.svg";
import ClipboardIcon from "./common-svg/clipboard.svg";
import email from "./common-svg/email.svg";
import stickyNote from "./common-svg/sticky-note.svg";
import crossConnection from "./common-svg/cross-connection.svg";
import bookSquare from "./common-svg/book-square.svg";
import productionIcon from "./common-svg/3d-rotate.svg";

import lockOutline from "./sidebar/lock-outline.svg";
import globeOutline from "./sidebar/globe-outline.svg";


export const images = {
  user,
  document,
  accounting,
  inventory,
  project,
  procurement,
  manufacturing,
  crm,
  hrms,
  office,
  rental,
  settings,
  addModule,
  logo,
  favicon,
  logout,
  tickicon,
  notification,
  question,
  vdivider,
  erp_logo,
  search,
  alert,
  more,
  forwardIcons,
  uploadIcon,
  sidebar: {
    document: documentIcon,
    document_text2,
    user: userIcon,
    roles,
    setting,
    accountingIcon,
    inventoryIcon,
    projectIcon,
    procurementIcon,
    manufacturingIcon,
    crmIcon,
    hrmsIcon,
    officeIcon,
    rentalIcon,
    dashboard,
    journalEntry,
    paymentEntry,
    paymentRequest,
    invoice,
    reports,
    credits,
    expenseReimbursement,
    commission,
    assets,
    budget,
    masterData,
    audit,
    settings: accountSideBarSettings,
    product,
    configuration,
    operations,
    notes,
    shoppingCart,
    book,
    calendar2,
    calendarEdit,
    task,
    boxTick,
    box,
    hierarchy,
    chartFail,
    report2,
    purchaseIcon,
    lockOutline,
    globeOutline,
    invoicing,
    stickyNote,
    crossConnection,
    bookSquare
  },
  avatar,
  avatarIcon,
  chat,
  common: {
    clearIcon,
    editIcon,
    calenderIcon,
    addIcon,
    resizeCardIcon,
    eyeSlashIcon,
    replaceIcon,
    trash,
    eyeIcon,
    dotsIcon,
    arrowIcon,
    saveFilterIcon,
    renameIcon,
    folderAdd,
    folderUpload,
    folderCloud,
    arrowRight,
    calendarTab,
    status,
    tickCircle,
    arrow,
    arrowRightCircle,
    directInbox,
    arrowDownCircle,
    gridViewData,
    textViewData,
    printer,
    tableNoData,
    operatinPlay,
    operationBlock,
    operationComplete,
    ArrowDown,
    ArrowUp,
    swap,
    collapse,
    expand,
    document_text,
    notification_manu,
    manu_block,
    manu_play,
    manu_completed,
    email,
  },
  TableIcon,
  CalenderIcon,
  GanttIcon,
  KanbanIcon,
  GridIcon,
  ChartIcon,
  gantt,
  grid,
  table,
  calendar,
  kanban,
  userFallback,
  roleFallback,
  settingsFallback,
  invoiceFallback,
  reportsFallback,
  demandasFallback,
  operationFallback,
  shippmentFallback,
  deliveryOrderFallback,
  upload: {
    empty,
    close,
    folder,
    tick,
    uploading,
    docFile,
    documentPDF,
    trash,
    monitor,
    documentUpload,
    camera,
    documentUploadWhite,
    coupon,
    applyBadge,
  },
  uploadDocument,
  uploadImage,
  info,
  url,
  location,
  sms,
  dollar,
  // dollarPendingBilling,
  relation,
  sharedPage: {
    calendarView,
    ganttView,
    gridView,
    kanbanView,
    tableView,
  },
  edit,
  duplicate,
  docfolder,
  file,
  gallery,
  mp4,
  pdf,
  trashIcon,
  login: {
    LoginLeftBg,
    LoginLeftSiteImage,
  },
  inventoryModule: {
    item: InventoryItem,
  },
  vendorPerformance,
  customerPerformance,
  cashFlow,
  fileUpload,
  accountPayable,
  accountReceivable,
  financialSummery,
  boxTickGreen,
  expandIcon,
  threeDotIcon,
  ArrowDownFill,
  PackageIcon,
  TraceDetailIcon,
  ArrowCircleUpIcon,
  ClipboardIcon,
  productionIcon
};

export default images;
